module.exports = __webpack_public_path__ + "img/one.594dcdcf.png";